import React, { useState } from "react";
import { Button, Col, Modal } from "react-bootstrap";
import MePosIcon from "../../..//page/FirstScreen/MePosBlock/svg/MePosIcon";
import { useSelector } from "react-redux";

function PosModal({ show, handleClose }) {
  const lang = useSelector((state) => state.changeLang.language.modalPos);
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0">
        </Modal.Header>
        <Modal.Body className="text-center pb-5">
          <MePosIcon />
          <Col xs={10} className="mx-auto  mt-4">
            <h4>{lang[0]}</h4>
            <p className="text-gray px-4 mb-4">{lang[1]}</p>
          </Col>
          <Col xs={6} className="mx-auto">
            <Button variant="primary" className="btn btn-main-pos py-3 fw-bold w-100" onClick={handleClose}
                    href="https://me-pos.com/?utm_source=me-qr&utm_medium=banner&utm_campaign=generator-type"
                    target="_blank">
              {lang[2]}
            </Button>
          </Col>
        </Modal.Body>
      </Modal>

  );
}


export default PosModal;
